var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCustomFieldPicture = function SvgCustomFieldPicture(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.01 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#717171;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img"
  }, /*#__PURE__*/React.createElement("g", {
    id: "simbolo-de-boton-de-interfaz-cuadrado-de-imagenes"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_6",
    "data-name": 6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_142",
    "data-name": "Grupo 142"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_164",
    "data-name": "Trazado 164",
    className: "cls-1",
    d: "M3,1.53A1.49,1.49,0,1,0,4.51,3,1.49,1.49,0,0,0,3,1.53ZM3,3.76A.74.74,0,0,1,2.28,3,.75.75,0,0,1,3,2.27.76.76,0,0,1,3.77,3,.75.75,0,0,1,3,3.76ZM10.48,0h-9A1.49,1.49,0,0,0,0,1.53v8.94A1.49,1.49,0,0,0,1.53,12h9A1.49,1.49,0,0,0,12,10.47V1.53A1.49,1.49,0,0,0,10.48,0Zm-9,11.18a.75.75,0,0,1-.74-.75v-.35l3-2.65,3.74,3.75Zm9.69-.75a.75.75,0,0,1-.74.75H8.55L5.8,8.43,9,5.25l2.24,2.24Zm0-4.05L9,4.14,5.28,7.9,3.77,6.37l-3,2.74V1.53A.75.75,0,0,1,1.53.78h9a.75.75,0,0,1,.74.75Z"
  })))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCustomFieldPicture);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "custom_field-picture.91742f7cb86ca48d1eab31974ba06065.svg";